import React from "react";
import { useLanguage } from "../../context/LanguageProvider";
import { languages } from "../../constants/translations";
import { LanguageInfo } from "../../types";

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setLanguage(event.target.value);
  };

  return (
    <div className="relative inline-block text-left z-50">
      {" "}
      <select
        id="language-select"
        value={language}
        onChange={handleLanguageChange}
        className="block w-full pl-3 pr-8 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-primary focus:border-primary cursor-pointer"
        aria-label="Select Language"
      >
        {languages.map((lang: LanguageInfo) => (
          <option key={lang.code} value={lang.code}>
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
